module.exports = __webpack_public_path__ + "static/media/paytrust_logo.fef1600f.svg";